export const ALL_SPACE = /\s/g;
export const MAIL_FORMAT = '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.]{1}[a-zA-Z]{2,}$';
export const LAT_LON_REGEX = /^((-?|\+?)?\d+(\.\d+)?)\s*((-|\+?)?\d+(\.\d+)?)$/;
export const LAT_LON_MASK = /^-?[\d.]{0,20}\s*-?[\d.]{0,20}$/;
export const REGEX_FOR_INTEGER_NUMBERS = new RegExp('[0-9]');
export const TIME_DOUBLE_REG_EXP = /^\d{2,3}:[0-5][0-9]$/;
export const TIME_DOUBLE_PATTERN = '00[0]:00';

